interface SearchProps<T> {
  name: string;
  subs?: T[];
}

export const searchTreeList = <T extends SearchProps<T>>(nodes: T[], query: string): T[] => {
  const lowerCaseQuery = query.toLowerCase();  
  return nodes.map(node => {
    const newNode = { ...node }
    // 如果节点匹配，或者其子节点中有匹配的（即使当前节点不匹配
    if (node.name.toLowerCase().includes(lowerCaseQuery) || (node.subs && node.subs.some(child => child.name.toLocaleLowerCase().includes(lowerCaseQuery)))) {
      // 递归搜索子节点
      newNode.subs = searchTreeList(node.subs || [], query);
    } else if (node.subs) {  
      // 如果没有匹配，但子节点存在，则过滤子节点（移除没有匹配的子树）  
      newNode.subs = node.subs.filter(child =>  
        searchTreeList([child], query).length > 0  
      );  
    } else {
      newNode.subs = undefined;
    }
    return newNode;
  }).filter(node => node.subs && node.subs.length > 0 || node.name.toLowerCase().includes(lowerCaseQuery)); // 过滤掉没有子节点且不匹配根查询的节点  
}